import ReportTextureCluster from './ReportTextureCluster';
export default ReportTextureCluster;
